import {PanelMenu} from "primereact/panelmenu";
import "./MainMenu.scss";
import {useEffect, useState} from "react";
import useWindowDimensions from "../../hooks/DimensionsHook";

interface SubmenuItem {
    label: string;
    command: () => void;
};

interface MenuItemProps {
    label: string;
    icon?: string;
    items?: SubmenuItem[];
    command?: () => void;
};

interface MainMenuProps {
    menuItemList: MenuItemProps[];
};

export const MainMenu = (p: MainMenuProps) => {
    const { menuItemList  } = p;
    const [ isVisible, setIsVisible ] = useState<boolean>(false)
    const [ isOpen, setIsOpen ] = useState<boolean>(false)
    const { dimensions, isMobile } = useWindowDimensions();

    return (
        <div className="main-menu-container">
            {(isMobile) &&
                <div style={{height: '40px', color: "white", textAlign: "right"}} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsOpen(!isOpen)
                }}>
                    {!isOpen && <i className="pi pi-bars" style={{fontSize: 30, margin: "5px"}}></i>}
                    {isOpen && <i className="pi pi-times" style={{fontSize: 30, margin: "5px"}}></i>}
                </div>
            }
            {(isOpen || !isMobile) && <PanelMenu model={menuItemList}  multiple={true} /> }
        </div>
    );
};
